import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import AIVisibility from "@/components/AIVisibility";
import AIMetrics from "@/components/AIMetrics";
import Approach from "@/components/Approach";
import Services from "@/components/Services";
import CaseStudies from "@/components/CaseStudies";
import Pricing from "@/components/Pricing";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import CTASection from "@/components/CTASection";
import BookingCalendar from "@/components/BookingCalendar";
import Footer from "@/components/Footer";

import { OrganizationSchema, WebSiteSchema, ServicesSchema, LocalBusinessSchema, BreadcrumbSchema } from "@/components/seo/StructuredData";

const homeBreadcrumbs = [
  { name: "Accueil", url: "https://gogenia.ai/" }
];

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Structured Data for SEO */}
      <OrganizationSchema />
      <WebSiteSchema />
      <ServicesSchema />
      <LocalBusinessSchema />
      <BreadcrumbSchema items={homeBreadcrumbs} />
      
      <Header />
      <main>
        <Hero />
        <Stats />
        <AIVisibility />
        <AIMetrics />
        <Approach />
        <Services />
        <CaseStudies />
        <Pricing />
        <BookingCalendar />
        <Contact />
        <FAQ />
        <CTASection />
      </main>
      <Footer />
      
    </div>
  );
};

export default Index;
